"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrmCustomPropertyType = void 0;
var CrmCustomPropertyType;
(function (CrmCustomPropertyType) {
    CrmCustomPropertyType["Text"] = "text";
    CrmCustomPropertyType["Number"] = "number";
    CrmCustomPropertyType["Phone"] = "phone";
    CrmCustomPropertyType["Email"] = "email";
    CrmCustomPropertyType["Date"] = "date";
    CrmCustomPropertyType["Boolean"] = "boolean";
    CrmCustomPropertyType["MultiSelect"] = "multi-select";
    CrmCustomPropertyType["SingleSelect"] = "single-select";
})(CrmCustomPropertyType || (exports.CrmCustomPropertyType = CrmCustomPropertyType = {}));
